/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoCalendar implements angular.IDirective {
    restrict = "E";
    require = "ngModel";
    scope = {
      minDate: "=",
      maxDate: "=",
      ngModel: "=ngModel"
    };

    template = "<md-calendar id=\"{{ ngModel + $parent.$index }}\" ng-model=\"ngModel\" md-min-date=\"minDate\" md-max-date=\"maxDate\"></md-calendar>";

    static factory(): angular.IDirectiveFactory {
      let directive = () => {
        return new MeevoCalendar();
      };

      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoCalendar", MeevoCalendar.factory());
}